// @flow
import React from 'react';

import Grid from 'Components/frameworks/grid/Grid';
import { LineTitle } from 'Components/widgets/line-title/LineTitle';
import { Product } from 'Components/widgets/product/Product';
import type { ProductProps } from 'Components/widgets/product/Product.utils';

export type Props = {
  className?: string,
  fetchData?: string => void,
  isLoading?: boolean,
  grid?: ScreenSizesProps,
  display?: ScreenSizesProps,
  hasSeeMore: boolean,
  products: $ReadOnlyArray<ProductProps>,
  seeMore?: SeeMoreProps,
  title?: string,
  totalNumberToDisplay?: number,
  onComparisonClick?: (id: string) => mixed,
  offer?: Offer,
  isSynchronousGrid?: boolean,
};

export const ProductsGrid = ({
  className,
  fetchData,
  grid,
  display,
  hasSeeMore,
  isLoading,
  seeMore,
  title = '',
  totalNumberToDisplay,
  products,
  onComparisonClick,
  offer,
  isSynchronousGrid = false,
}: Props) => {
  if (products.length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {!!title && <LineTitle>{title}</LineTitle>}
      <Grid
        display={display || grid}
        getChildren={fetchData}
        grid={grid}
        hasSeeMore={hasSeeMore}
        isLoading={isLoading}
        seeMore={seeMore}
        totalNumberToDisplay={totalNumberToDisplay}
        isSynchronousGrid={isSynchronousGrid}
      >
        {products.map(product => (
          <Product
            key={product.id}
            offer={offer}
            {...product}
            onComparisonClick={onComparisonClick ? () => onComparisonClick(product.id) : undefined}
          />
        ))}
      </Grid>
    </div>
  );
};

ProductsGrid.defaultProps = {
  hasSeeMore: false,
  products: [],
};
